<template>
    <!--
        간단 안내/오류 메시지용 재사용 모달.
        alert() 대체 목적. ref 로 open(message[, title]) 호출해 띄운다.
        message 의 줄바꿈(\n)은 문단으로 분리되어 표시된다.
    -->
    <v-dialog v-model="shows" width="400">
        <v-card class="common-message-dialog">
            <v-card-title v-if="title" class="common-message-dialog__title justify-center text-center">
                {{ title }}
            </v-card-title>
            <v-card-text class="common-message-dialog__info text-center">
                <p v-for="(line, index) in lines" :key="index">{{ line }}</p>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn color="primary" @click="exit"> {{ confirmText }} </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        title: { type: String, default: "안내" },
        confirmText: { type: String, default: "확인" },
    },
    data: () => ({
        shows: false,
        message: "",
        onCloseHandler: null,
    }),
    computed: {
        lines() {
            return String(this.message ?? "")
                .split("\n")
                .filter((line) => line.trim().length);
        },
    },
    methods: {
        /**
         * @param {string} message 표시할 메시지 (줄바꿈 \n 지원)
         * @param {() => void} [onClose] 닫힘(확인/배경클릭 무관) 시 1회 실행할 콜백
         */
        open(message, onClose) {
            if (message != null) this.message = message;
            this.onCloseHandler = typeof onClose === "function" ? onClose : null;
            this.shows = true;
        },
        exit() {
            this.shows = false;
        },
    },
    watch: {
        // 확인 버튼·배경 클릭 등 어떤 방식으로 닫혀도 동일하게 처리한다.
        shows(value) {
            if (value) return;

            this.$emit("close");

            let handler = this.onCloseHandler;
            this.onCloseHandler = null;
            if (handler) handler();
        },
    },
};
</script>

<style lang="scss" scoped>
.common-message-dialog {
    &__info {
        white-space: pre-line;

        & > p:not(:last-of-type) {
            margin-bottom: 8px;
        }
    }
}
</style>
